import Vue from 'vue';
import Vuex from 'vuex';

import menu from './menu.module'
import breadcrumb from './breadcrumb.modules'
import alerts from './alerts.module'
import auth from './auth.module'
import facility from './facilities.module'
import site from './sites.module'
import job from './jobs.module'
import jobDocuments from './jobDocuments.module'
import meetingDocuments from './meetingDocuments.module'
import siteDocuments from './siteDocuments.module'
import invoices from './invoices.module';
import forums from './forums.module';
import committees from './committees.module'
import publication from './publication.module'
import subscription from './subscription.module'
import userRequest from './userRequest.module'
import notification from './notification.module'
import lastUsedTAReport from './lastUsedTAReport.module'
import cacAcknowledgeTAReport from './cacAcknowledgeTAReport.module'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    menu,
    breadcrumb,
    alerts,
    auth,
    site,
    facility,
    job,
    jobDocuments,
    meetingDocuments,
    siteDocuments,
    invoices,
    forums,
    committees,
    publication,
    subscription,
    userRequest,
    notification,
    lastUsedTAReport,
    cacAcknowledgeTAReport
  },
});
